/** Prefix used to distinguish group-container drop ids from row-label drop
 *  ids in the measurements section's cross-group drag handler. Stored as a
 *  single source of truth so both the droppable group and the drag-end
 *  handler agree on the format. */
export const GROUP_DROP_PREFIX = 'group:';
